import { finalDispatch } from './dispatcher';
import { getGlobalContext } from './globalContext';
export default function applyMiddleware() {
    var middleware = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        middleware[_i] = arguments[_i];
    }
    var next = finalDispatch;
    for (var i = middleware.length - 1; i >= 0; i--) {
        next = applyNextMiddleware(middleware[i], next);
    }
    getGlobalContext().dispatchWithMiddleware = next;
}
function applyNextMiddleware(middleware, next) {
    return middleware.bind(null, next);
}
